/**
 * @generated SignedSource<<9492f8672eead26e9f23e54767f55a30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BookmarkTabModalGetLinkQuery$variables = {
  link: string;
};
export type BookmarkTabModalGetLinkQuery$data = {
  readonly getLinkInfo: {
    readonly icon: string | null;
    readonly isEmbeddable: boolean;
    readonly stream: {
      readonly id: string;
    } | null;
    readonly title: string;
  } | null;
};
export type BookmarkTabModalGetLinkQuery = {
  response: BookmarkTabModalGetLinkQuery$data;
  variables: BookmarkTabModalGetLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "link"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "link"
      }
    ],
    "concreteType": "CheckLinkNode",
    "kind": "LinkedField",
    "name": "getLinkInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEmbeddable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarkTabModalGetLinkQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookmarkTabModalGetLinkQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b522cd808ac2d1234bfa97fa5d10e316",
    "id": null,
    "metadata": {},
    "name": "BookmarkTabModalGetLinkQuery",
    "operationKind": "query",
    "text": "query BookmarkTabModalGetLinkQuery(\n  $link: String!\n) {\n  getLinkInfo(url: $link) {\n    title\n    icon\n    isEmbeddable\n    stream {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e8ea063c0c33104945e760ec61ebb5c";

export default node;
